import ApiHelper from "../../ApiHelper";

const STUDENT_CERTIFICATE_BASE_URL = '/student/certificates';

class StudentCertificateHelper {
  // =====================================================
  // GET METHODS
  // =====================================================

  /**
   * Get all certificates for the logged-in student
   * GET /api/student/certificates
   * Returns only approved certificates
   */
  async getMyCertificates() {
    try {
      const response = await ApiHelper.get(STUDENT_CERTIFICATE_BASE_URL);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch certificates: ${error.message}`);
    }
  }

  /**
   * Check if certificate is available for a course
   * GET /api/student/certificates/check/:courseId
   * @param {string} courseId - Course UUID
   * @returns {Object} { isAvailable, status, message, certificateId?, certificateNumber? }
   */
  async checkCertificateAvailability(courseId) {
    try {
      const response = await ApiHelper.get(
        `${STUDENT_CERTIFICATE_BASE_URL}/check/${courseId}`
      );
      return response;
    } catch (error) {
      throw new Error(`Failed to check certificate availability: ${error.message}`);
    }
  }

  /**
   * Get certificate data by course ID
   * GET /api/student/certificates/course/:courseId
   * @param {string} courseId - Course UUID
   * @returns {Object} Certificate data for PDF generation
   */
  async getCertificateByCourse(courseId) {
    try {
      const response = await ApiHelper.get(
        `${STUDENT_CERTIFICATE_BASE_URL}/course/${courseId}`
      );
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch certificate by course: ${error.message}`);
    }
  }

  /**
   * Get certificate data for download
   * GET /api/student/certificates/:certificateId/download
   * @param {string} certificateId - Certificate UUID
   * @returns {Object} Formatted data for client-side PDF generation
   */
  async getCertificateForDownload(certificateId) {
    try {
      const response = await ApiHelper.get(
        `${STUDENT_CERTIFICATE_BASE_URL}/${certificateId}/download`
      );
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch certificate for download: ${error.message}`);
    }
  }
}

export default new StudentCertificateHelper();